const css = `.ZpSR7W__content{width:100%;box-sizing:border-box;flex-direction:column;justify-content:center;display:flex;overflow:hidden}.ZpSR7W__inset{padding-left:36px}.ZpSR7W__text{word-break:break-word}.ZpSR7W__badge{margin-top:3px}.ZpSR7W__badge.ZpSR7W__compact{margin-top:0}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"badge":"ZpSR7W__badge","inset":"ZpSR7W__inset","compact":"ZpSR7W__compact","text":"ZpSR7W__text","content":"ZpSR7W__content"};
